<template>
  <v-layout fill-height column id="tutorialGuide05">
    <v-main class="page-square page-square-main tutorial-guide-content"
            :style="{'background': `url(${background}) center top no-repeat`, 'background-size': '100% auto'}">
      <v-app-bar
          :app="false"
          flat
          dense
          dark
          color="transparent"
          height="119px"
          :style="{
            'background': `url(${background}) center top no-repeat`,
            'background-size': '100% auto',
            'padding-bottom': '30px'
          }"
      >
        <template #img="{}">
          <div class="pa-5 fs-24 font-weight-bold white--text line-height-tight">
            오늘 홍길동님과<br/>
            함께하는 사람들의 <br/>
            마음날씨는 보통이예요.
          </div>
        </template>
        <template #extension>
          <v-tabs dark hide-slider class="tabs" background-color="transparent">
            <v-tab replace :ripple="false" class="fs-16" @click.prevent>전체</v-tab>
            <v-tab replace :ripple="false" class="fs-16" @click.prevent>내가 쓴 글</v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
      <v-sheet class="scrolling-container">

        <article class="square-unit-item" v-for="index in 5" :key="index">
          <v-tooltip attach
                     left
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <div class="square-unit-item-part01"
                   v-bind="attrs"
              >
                <header class="unit-header">
                  <div class="d-flex align-center">
                    <v-avatar min-width="40" width="40" height="40">
                      <img :src="require('@/assets/images/avatar/profile_img_00.jpg')" />
                    </v-avatar>
                    <dl class="unit-header-info">
                      <dt class="name">홍길동</dt>
                      <dd class="date">2023.08.09</dd>
                      <dd class="mission">1일차 미션</dd>
                    </dl>
                  </div>
                  <v-btn icon plain :ripple="false"
                         class="btn-sheet-menu"
                         @click.p.prevent></v-btn>
                </header>
                <div class="unit-body">
                  <div class="unit-text">
                    <div class="text-pre-wrap">
                      꾸준히 하기 쉽지 않지만 챙겨보기!
                    </div>
                  </div>
                </div>
                <div class="square-unit-info"
                     @click.p.prevent>
                  <div class="tit">마음날씨</div>
                  <div class="txt">
                    1:00 | 인식표현, 관계
                  </div>
                </div>
              </div>
            </template>
            <span v-if="index === 1" class="tooltip-text" id="tooltipSquareItem">
              미션 후 소감 글을 남기면 <br />
              광장의 다른 사람들과 공유할 수 있어요.
            </span>
          </v-tooltip>
          <footer class="unit-footer">
            <v-tooltip attach
                       bottom
                       max-width="100vw"
                       class="tooltip-coach"
                       :value="tooltipActive">
              <template v-slot:activator="{ attrs }">
                <v-btn text plain :ripple="false"
                       class="btn-comment"
                       v-bind="attrs"
                       @click.prevent
                ><i></i>0</v-btn>
                <v-btn text plain :ripple="false"
                       class="btn-like"
                       @click.prevent
                ><i></i>0</v-btn>
              </template>
              <span v-if="index === 1" class="tooltip-text" id="tooltipSquareBtn">
                다른 사람들의 소감에<br />
                칭찬과 댓글을 달아보세요!
              </span>
            </v-tooltip>
          </footer>
        </article>

      </v-sheet>
      <slot name="bottomMenu" />
    </v-main>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
export default {
  name: 'TutorialSlide5',
  components: {},
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({
    tooltipActive: false,
    background: require('@/assets/images/bg_square.png')
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<!--<style lang="scss" src="@/assets/sass/page/_tutorial.scss" scoped></style>-->
<style lang="scss" scoped>
.tooltip-coach {
  #tooltipSquareItem {
    left: 100px;
    bottom: 130px;
    text-align: right;
    &:after {
      left: -50px;
      top: 20px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #tooltipSquareBtn {
    left: 15px;
    &:after {
      width: 56px;
      height: 55px;
      left: -50px;
      top: -44px;
      background-image: var(--coach-mark-arrow-02);
    }
  }
}
.tutorial-guide-content::v-deep {
  .scrolling-container {
    box-sizing: border-box;
    margin-top: -30px;
    height: calc(calc(var(--vh, 1vh) * 100) - 167px - 100px - var(--system-bar-height) - var(--system-bottom-height));
    padding: 20px 20px 0;
    border-radius: 30px 30px 0 0;
    //overflow: hidden;
    z-index: 8;
    &::after {
      content: "";
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .75);
      z-index: 7;
    }
  }
  .square-unit-item:first-child {
    position: relative;
    z-index: 8;
  }
  .square-unit-item-part01 {
    padding: 5px;
    margin: -5px;
    border-radius: 20px;
    background-color: #fff;
  }
  .unit-footer {
    .v-btn {
      background-color: #fff;
      border-radius: 0 !important;
      &:first-child {
        border-radius: 20px 0 0 20px !important;
      }
      &:last-child {
        padding-left: 0 !important;
        border-radius: 0 20px 20px 0 !important;
      }
    }
  }
}
</style>
